export var StatusCode;
(function (StatusCode) {
    StatusCode[StatusCode["AUTHORIZATION_FAILED"] = 1] = "AUTHORIZATION_FAILED";
    StatusCode[StatusCode["FORBIDDEN"] = 2] = "FORBIDDEN";
    StatusCode[StatusCode["INTERNAL_SERVER_ERROR"] = 3] = "INTERNAL_SERVER_ERROR";
    StatusCode[StatusCode["RESTRICTED"] = 4] = "RESTRICTED";
})(StatusCode || (StatusCode = {}));
//# sourceMappingURL=StatusCode.js.map